import { isEmpty, isNull } from 'lodash';
import { useSelector } from 'react-redux';

import { getCurrentWorkspaceSelector } from '@app/reducers/app';
import type { FilterComponentInterface } from '@app/hocs/search/filter/types';

import { FolderTree } from '@app/components/folder-tree';

type FolderFilterValue = number[] | null;

export const getFolderFilterValue = (filterValue: FolderFilterValue) => {
  if (isNull(filterValue) || isEmpty(filterValue)) {
    return null;
  }

  return filterValue[0];
};

export const FolderFilter = ({ value, onChange }: FilterComponentInterface<FolderFilterValue>) => {
  const currentWorkspace = useSelector(getCurrentWorkspaceSelector);
  const _value = getFolderFilterValue(value);
  const handleChange = (folderId: Oneflow.Folder['id']) => {
    if (isNull(folderId)) {
      onChange(null);
    } else {
      onChange([
        folderId,
      ]);
    }
  };
  return (
    <FolderTree
      selectedUniqueKey={_value}
      selectedWorkspaceId={currentWorkspace.id}
      selectedWorkspaceName={currentWorkspace.name || ''}
      // double check the shared with me workspace case
      selectedWorkspace={currentWorkspace as Oneflow.Workspace}
      onChange={handleChange}
    />
  );
};
